import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FilterListService } from 'gung-list';

@Injectable({
  providedIn: 'root'
})
export class ColmecFilterListServiceService<T> extends FilterListService<T> {
  enableSaveSearch = true;

  constructor(route: ActivatedRoute) {
    super(route);
  }
}
